export const SET_MODAL_DISCOUNT_LIMIT = 'FISCAL/SET_MODAL_DISCOUNT_LIMIT';
export const SET_CFOP_COLLECTION = 'FISCAL/SET_CFOP_COLLECTION';
export const SET_ISS_EXIBILITY_COLLECTION = 'FISCAL_COMPONENTS/SET_ISS_EXIBILITY_COLLECTION';
export const SET_TAX_REGIME_COLLECTION = 'FISCAL_COMPONENTS/SET_TAX_REGIME_COLLECTION';
export const SET_NBS_COLLECTION = 'FISCAL_COMPONENTS/SET_NBS_COLLECTION';
export const SET_NFSE_NATURE_CODES_COLLECTION =
  'FISCAL_COMPONENTS/SET_NFSE_NATURE_CODES_COLLECTION';
export const SET_NFSE_NATURE_OF_OPERATION_COLLECTION =
  'FISCAL_COMPONENTS/SET_NFSE_NATURE_OF_OPERATION_COLLECTION';
export const SET_NFSE_RESPONSIBLE_RETENTION_COLLECTION =
  'FISCAL_COMPONENTS/SET_NFSE_RESPONSIBLE_RETENTION_COLLECTION';
